// src/config/paymentOptions.ts
export interface PaymentOption {
    amount: number;
    bonusPercentage: number; // Процент бонуса
    label?: string; // Опциональная метка, например "Хит"
  }
  
  export const paymentOptions: PaymentOption[] = [
    { amount: 500, bonusPercentage: 10 },       // 10% = 50 ₽
    { amount: 1000, bonusPercentage: 15, label: 'Хит' }, // 15% = 150 ₽
    { amount: 2000, bonusPercentage: 17.5 },    // 17.5% = 350 ₽
  ];